/* eslint-disable no-underscore-dangle */
import { Button, Select } from '@salt/components';
import React, { useCallback, useState } from 'react';
import { moveUsers } from '../../api/users';

const MoveProjectModal = ({ handleMoveProjectModalClose, user, projects, fetchData }) => {
  const [newProject, setNewProject] = useState('');

  const onMove = useCallback(() => {
    moveUsers({ projectId: newProject, userIds: [user.id] })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to move user');
      });
    handleMoveProjectModalClose();
  }, [newProject, user]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleMoveProjectModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="modal-title">
          <h2 className="w-full mb-2 font-[18px] text-center">Move User Between Projects</h2>
          <div>
            <span className="text-base">Current Project</span>
            <div className="mt-2 p-4 bg-[#F9FAFC] flex text-base items-center">
              {user.name}
              <div
                title={user.project?.name || 'Unknown'}
                style={{
                  backgroundColor: `${user.project?.accent_colour || '#37C2D7'}40`,
                  color: user.project?.accent_colour || '#37C2D7',
                }}
                className="rounded-full py-1 px-3 text-center truncate w-fit ml-auto"
              >
                {user.project?.name || 'Unknown'}
              </div>
            </div>
            <div className="text-base mt-6 mb-4">
              Move to
              <div className="mt-4">
                <Select
                  onClick={(newVal) => setNewProject(newVal)}
                  width="w-full"
                  labelBackgroundClass={`group-focus:bg-secondary-light ${newProject?.length > 0 ? 'bg-secondary-light' : ''}`}
                  backgroundClass="bg-secondary-light"
                  placeholder="Select a Project"
                  renderItems={projects
                    .filter((p) => p.id !== user.project?.id)
                    .map((p) => ({
                      id: String(p.id),
                      value: p.name,
                      render: () => {},
                    }))}
                  value={projects.find((p) => String(p.id) === newProject)?.name}
                  permScroller={projects.length > 4}
                />
              </div>
            </div>
          </div>

          <div>
            <br />
            <Button
              onClick={handleMoveProjectModalClose}
              type="neutral"
              className="max-w-[146px] h-[36px] ml-auto"
              paddingClassName="px-6"
            >
              Cancel
            </Button>
            <Button
              onClick={onMove}
              disabled={newProject.length === 0}
              type="positive"
              className="max-w-[146px] h-[36px] ml-auto float-right"
              paddingClassName="px-6"
            >
              Move
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveProjectModal;
